"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=pluginManifest.js.map